module.exports = __webpack_public_path__ + "img/odoo-sales.adbe7cb1.png";